import { Component } from '@angular/core'

@Component({
  selector: 'se-po-household-setup-whos-participating-docs',
  templateUrl: './who-docs.component.html',
  styleUrls: ['./who-docs.component.scss'],
  standalone: false,
})
export class WhoDocsComponent { }
